import { useMemo } from 'react'
import { FiActivity } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'

import type { ReactElement } from 'react'
import type { MobileDeviceType } from '~/types/device-type'

import CompetitorsBlock from './CompetitorsBlock'
import EventsBlock from './EventsBlock'
// import GeneralAnalyticsBlock from './GeneralAnalyticsBlock'
import InstallsOverTimeBlock from './InstallsOverTimeBlock'
import LegacyBlock from './LegacyBlock'
import VersionsBlock from './VersionsBlock'

import HeaderSummary from '~/components/Header/Summary'
import NavigationBlock from '~/components/NavigationBlock'
import YesterdayDate from '~/components/YesterdayDate'
import useDocumentTitle from '~/hooks/useDocumentTitle'
import { useAppSummary } from '~/providers/AppSummary'
import { useAppEventsListQuery } from '~/queries/events'
import { useChartConfigsListQuery } from '~/queries/graphs-builder'
import { CA_PAGES } from '~/types/graph-builder'
import { formatConfig } from '~/utils/graphs-builder'

import './styles.scss'

const KPI_FIELD = 'installation_date'

const PAGE = CA_PAGES.APP_SUMMARY

const AppSummary = (): ReactElement => {
  /** Local state */

  const { appKey, deviceType } = useAppSummary()

  const navigate = useNavigate()

  /** Queries & Mutations */

  const { data: chartConfigs } = useChartConfigsListQuery({
    appKey,
    deviceType,
    pageName: PAGE,
  })

  const formattedConfigs = useMemo(() => formatConfig(chartConfigs?.data), [chartConfigs?.data])

  const { data: eventsData = [], isLoading: isEventsLoading } = useAppEventsListQuery({
    appKey,
    deviceType: deviceType as MobileDeviceType,
  })

  /** Effects */

  useDocumentTitle('Summary')

  /** Handlers */

  const handleBlockClick = (url: string) => () => navigate(url)

  /** Render */

  return (
    <>
      <HeaderSummary />
      <div className="app-summary-view">
        <div className="app-summary-view__content">
          <NavigationBlock
            className="general-analytics-block"
            clickable
            infoTitle={<YesterdayDate />}
            onClick={handleBlockClick('/ca/overview')}
            title="General analytics"
          >
            <LegacyBlock />
            {/* <GeneralAnalyticsBlock
            appKey={appKey}
            chartConfigs={formattedConfigs}
            deviceType={deviceType as MobileDeviceType}
            kpiField={KPI_FIELD}
          /> */}
          </NavigationBlock>
          <NavigationBlock
            className="data-block installs-over-time"
            icon={<FiActivity size={21} />}
            title="Installs over time"
          >
            <InstallsOverTimeBlock
              appKey={appKey}
              chartConfigs={formattedConfigs}
              deviceType={deviceType as MobileDeviceType}
              eventsData={eventsData}
              isEventsLoading={isEventsLoading}
              kpiField={KPI_FIELD}
            />
          </NavigationBlock>
          <NavigationBlock
            className="data-block events-block"
            clickable
            onClick={handleBlockClick('/events')}
            title="Last events"
          >
            <EventsBlock eventsData={eventsData.slice(0, 3)} isEventsLoading={isEventsLoading} />
          </NavigationBlock>
          <NavigationBlock
            className="data-block versions-block"
            clickable
            onClick={handleBlockClick('/versions')}
            title="Last versions"
          >
            <VersionsBlock />
          </NavigationBlock>
          <NavigationBlock className="data-block competitors-block" title="Some competitors">
            <CompetitorsBlock />
          </NavigationBlock>
        </div>
      </div>
    </>
  )
}

export default AppSummary
